import React,{useState} from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../../atoms/checkBox/Checkbox';
import { PromotionStyle } from './ContractDurationStyle';

const ContractDurationItem = (props) => {
    let [check, setCheck] = useState(false);
    const handleContractDurationCheck = (event) => {
        let flag=event.target.checked;
        setCheck(flag)
        props.contractdurationClickHandler(flag)
    }
    const checkFilteredContractDuration = () => {
        return props.filteredContractDuration.filter(brand => brand.label === props.contractduration.label).length > 0 ? true : false
    }

    return (
        <ul className='list'>
            <li>
                <Checkbox
                isChecked={
                    props?.filteredContractDuration?.length > 0 ? checkFilteredContractDuration() :
                    props?.filteredContractDuration?.length === 0 ? false : check
                }
                id={`${props.contractduration.label}`}
                check={`${props.contractduration.label} months `}
                click={handleContractDurationCheck}
                />
            </li>
            <style jsx>{PromotionStyle}</style>
        </ul>
    );
};

ContractDurationItem.propTypes = {
    promotion: PropTypes.object,
    filteredPromotions: PropTypes.array,
    promoClickHandler: PropTypes.func,
    contractdurationClickHandler: PropTypes.func,
    filteredContractDuration: PropTypes.array,
    contractduration: PropTypes.object,
};

export default ContractDurationItem;

